import React, { useState, useCallback } from 'react';

export const useSafeState = (initialState) => {
  const [state, setState] = useState(initialState);
  
  const safeSetState = useCallback((newState) => {
    try {
      if (typeof newState === 'function') {
        setState(prevState => {
          try {
            return newState(prevState);
          } catch (error) {
            console.error('Error in state updater function:', error);
            return prevState;
          }
        });
      } else {
        setState(newState);
      }
    } catch (error) {
      console.error('Error setting state:', error);
    }
  }, []);

  return [state, safeSetState];
};